import { round } from 'lodash'
import { Column, Row, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

export type CategoryScoreType = {
  [key: string]: number
}

interface CategoryScoreProps {
  categoryScore: CategoryScoreType
  className?: string
}

const CategoryScore = ({ categoryScore, className }: CategoryScoreProps) => {
  if (!categoryScore) return

  const categoryScoresEntries = Object.entries(categoryScore)
  const data = categoryScoresEntries.map?.((item) => ({
    categoryName: item[0],
    categoryScore: item[1]
  }))

  return (
    <Column className={classNameBuilder('w-full space-y-5', className)}>
      <Text.Translated
        translationKey="title_category_score"
        size="lg"
        fontWeight="bold"
        color="600"
      />
      {data?.map((item, index) => (
        <Column key={index} className="space-y-3">
          <Row className="items-center justify-between space-x-4">
            <Text.Translated
              translationKey={`label_${item?.categoryName}_category_score`}
              size="xs"
              color="600"
            />
            <Text
              size="xs"
              fontWeight="bold"
              className="!text-electric-indigo-500"
            >
              {round(item?.categoryScore / 10, 1).toPrecision(2)} / 10
            </Text>
          </Row>
          <Column className="relative h-3 w-full overflow-hidden rounded-lg bg-[#D9D9D9]/50">
            <div
              className="absolute h-full rounded-lg rounded-r-none"
              style={{
                width: `${item?.categoryScore}%`,
                background: 'linear-gradient(90deg, #09D4E1 0%, #6A0DFD 100%)'
              }}
            />
          </Column>
        </Column>
      ))}
    </Column>
  )
}

export default CategoryScore
